import React, { useState, useEffect } from 'react';
import '../styles/AdminUserManager.css';
import AdminSidebar from './AdminSidebar';

const AdminUserManager = () => {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchUsers = async () => {
        try {
            const res = await fetch('/api/admin/users');
            const data = await res.json();
            setUsers(data.userList || []);
        } catch (err) {
            console.error("사용자 불러오기 실패", err);
        } finally {
            setIsLoading(false);
            console.log("사용자 목록:", users);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleUserClick = (user) => {
        setSelectedUser(user);
        console.log("선택된 사용자:", user);
    };

    const handleBlockUser = async () => {
        if (selectedUser.grade === 'ADMIN') {
            alert('관리자는 정지할 수 없습니다.');
            return;
        }
        if (selectedUser.grade === 'BLOCKED') {
            alert('이미 정지된 사용자입니다.');
            return;
        }
        if (!selectedUser) {
            alert('사용자를 선택하세요.');
            return;
        }

        if (!window.confirm(`${selectedUser.name}(${selectedUser.loginId}) 사용자를 정지하시겠습니까?`)) {
            return;
        }

        try {
            const res = await fetch(`/api/admin/user/${selectedUser.id}/block`, {
                method: 'PUT',
            });
            if (res.ok) {
                alert('사용자가 정지되었습니다.');
                fetchUsers();
                setSelectedUser(null);
            } else {
                alert('사용자 정지 실패');
            }
        } catch (err) {
            console.error("사용자 정지 오류", err);
        }
    };

    if (isLoading) return <p>Loading...</p>;

    return (
        <div className="user-manager">
            <AdminSidebar />
            <div className="user-manager-header">
                <h2>사용자 관리</h2>
            </div>
            <div>
                <table className="user-table">
                    <thead>
                    <tr>
                        <th>이름</th>
                        <th>아이디</th>
                        <th>이메일</th>
                        <th>전화번호</th>
                        <th>등급</th>
                        <th>가입일</th>
                        <th>마지막 로그인</th>
                        <th>포인트</th>
                        <th>총 구매액</th>
                    </tr>
                    </thead>
                    <tbody className={"user-tbody"}>
                    {users.map(user => (
                        <tr
                            key={user.id}
                            role="button"
                            onClick={() => handleUserClick(user)}
                            className={`${selectedUser?.id === user.id ? 'selected-row' : ''} ${user.grade === 'BLOCKED' ? 'blocked-row' : ''}`}
                        >
                        <td>{user.name}</td>
                            <td>{user.loginId}</td>
                            <td>{user.email}</td>
                            <td>{user.phoneNumber}</td>
                            <td>
                                {user.grade}
                            </td>
                            <td>{user.joinDate}</td>
                            <td>{user.latestLoginDate}</td>
                            <td>{user.point.toLocaleString()} P</td>
                            <td>{user.totalPurchaseAmount.toLocaleString()} 원</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <button onClick={() => {
                    handleBlockUser();
                }} className="block-button">
                    💀정지
                </button>
            </div>
        </div>
    );
};

export default AdminUserManager;
